import React, { JSX, useRef } from 'react';
import { Box, Button, HStack, Text, useDisclosure } from '@chakra-ui/react';
import { useScannedRelevosContext } from 'contexts/ScannedRelevosContext';

import './RelevosList.css';

import Dialog from '../../../../common/components/ConfirmationDialog/Dialog';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { ScannerMode } from '../../model/enums/scanner-mode.enum';
import { AssignItemsModal } from './AssignItemsModal';
import { ReturnItemsModal } from './ReturnItemsModal';

const SumUpConfirmButtons = (): JSX.Element => {
  const translations = useTranslations();
  const { scannedRelevos, setScannedRelevos, restaurantId, mode } = useScannedRelevosContext();

  const confirmRemoveModal = useDisclosure();
  const confirmRemoveCancelRef = useRef(null);

  const confirmAssignModal = useDisclosure();
  const confirmReturnModal = useDisclosure();

  const removeRelevos = () => {
    confirmRemoveModal.onClose();
    setScannedRelevos(() => []);
  };

  const handleConfirm = () => removeRelevos();

  const confirmButtonText =
    mode === ScannerMode.RETURN ? translations('scan_return_items') : translations('scan_assign_items');
  const confirmClearAllButtonText =
    mode === ScannerMode.RETURN
      ? translations('scan_clear_all_returns_confirm')
      : translations('scan_clear_all_assignments_confirm');

  return (
    <HStack textAlign="left" mt={2}>
      <Box pr="4px">
        <Button
          variant="orangeSolid"
          isDisabled={scannedRelevos.length < 1 || !restaurantId}
          title={confirmButtonText}
          onClick={() => (mode === ScannerMode.RETURN ? confirmReturnModal.onOpen() : confirmAssignModal.onOpen())}
          minWidth={144}
          margin="auto"
        >
          {confirmButtonText}
        </Button>
      </Box>
      <Box>
        <Button
          variant="transparent"
          color="orange.500"
          fontSize="16px"
          aria-label={translations('scan_remove_relevo')}
          disabled={scannedRelevos.length < 1}
          title={translations('scan_clear_all_relevo')}
          onClick={confirmRemoveModal.onOpen}
          margin="auto"
          minWidth={144}
        >
          {translations('scan_clear_all_relevo')}
        </Button>
      </Box>

      <Dialog
        isOpen={confirmRemoveModal.isOpen}
        leastDestructiveRef={confirmRemoveCancelRef}
        onClose={confirmRemoveModal.onClose}
        onConfirm={handleConfirm}
        cancelText={translations('scan_remove_cancel')}
        confirmText={translations('scan_remove_confirmed')}
      >
        <Text>{confirmClearAllButtonText}</Text>
      </Dialog>

      <ReturnItemsModal isOpen={confirmReturnModal.isOpen} onClose={confirmReturnModal.onClose} />
      <AssignItemsModal isOpen={confirmAssignModal.isOpen} onClose={confirmAssignModal.onClose} />
    </HStack>
  );
};

export default SumUpConfirmButtons;
